export const STATUS_CHANGED_EVENT = "Applicat.Bin_entrepot.Etat.Changed";
export const NOTIFICATION_EVENT = "Applicat.Entrepot_notif.Updated";
